export const CONTINUE_WITH_PHONE_CLICKED = 'Continue With Phone Clicked';
export const CONTINUE_WITH_EMAIL_CLICKED = 'Continue With Email Clicked';
export const CONTINUE_WITH_GOOGLE_CLICKED = 'Continue With Google Clicked';
export const CONTINUE_WITH_APPLE_CLICKED = 'Continue With Apple Clicked';

export const ROOM_ONBOARDING_STARTED = 'Room Onboarding Started';
export const ROOM_ONBOARDING_FINISHED = 'Room Onboarding Finished';
